import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Table from "../../../../../components/ui/Table";
import newSortBy from "../../../../../utils/newSortBy";
import { ISortBy } from "../../../../../types";
import { getSumAndCountSales } from "../utils";
import BillingHistoryTabsByEmail from "../BillibgHistoryTabsByEmail";
import { getAccountsSalesTableColumns } from "./constants";

interface IProps {
  sortBy: ISortBy;
  setSortBy: (sortBy: ISortBy) => void;
}

const AccountsSalesTable: React.FC<IProps> = ({ sortBy, setSortBy }) => {
  const { data, loading } = useSelector((state) => state.financials.passersStats);

  const [selectedRows, setSelectedRows] = useState<Array<number>>([]);

  const handleSortBy = (by: string) => newSortBy({ by, sortBy, setSortBy });

  const handleRowClick = (id: number) => {
    if (selectedRows.find((r) => r === id)) {
      setSelectedRows(selectedRows.filter((r) => r !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const { sumTotalAmount, sumUnitsSold } = getSumAndCountSales(data.sumBillingHistory);

  const dataWithSum = [
    ...data.sumBillingHistory,
    {
      id: "",
      name: "",
      email: "",
      total_amount: sumTotalAmount,
      units_sold: sumUnitsSold,
    },
  ];

  const columns = getAccountsSalesTableColumns(selectedRows, handleRowClick);

  useEffect(() => {
    setSelectedRows([]);
  }, [data]);

  const isHaveBillingHistory = !!data.sumBillingHistory.length;

  return (
    <div>
      <Table
        csv_table_name="Accounts sales"
        theadTitle="Accounts sales"
        columns={columns}
        loading={loading}
        data={isHaveBillingHistory ? dataWithSum : []}
        extractKey={(row) => row.id}
        sortBy={sortBy}
        handleSortBy={handleSortBy}
        isDownloadable
        noResultsMessage=""
      />

      {isHaveBillingHistory && <BillingHistoryTabsByEmail selectedRows={selectedRows} />}
    </div>
  );
};

export default AccountsSalesTable;
